import { put } from "api/put";
import { appendStatus } from "state/status/actions";

import _ from 'lodash';

export const GS_SALES_GROUPS_CLASSIFY_REQUEST = 'gs/sales-groups-classify/request';
export const GS_SALES_GROUPS_CLASSIFY_SUCCESS = 'gs/sales-groups-classify/success';
export const GS_SALES_GROUPS_CLASSIFY_FAILURE = 'gs/sales-groups-classify/failure';

export function updateSalesGroups(days) {
  return async (dispatch) => {

    dispatch({
      type: GS_SALES_GROUPS_CLASSIFY_REQUEST,
      payload: null
    });

    try {
      const resp = await put("products/sales-group-classify", {
        days: parseInt(days)        
      });
            
      const payload = _.get(resp, 'data.payload', {});
      
      dispatch({
        type: GS_SALES_GROUPS_CLASSIFY_SUCCESS,
        payload: payload,
      });

      dispatch(
        appendStatus(
          "Sales groups re-generated successfully.",
          "info"
        )
      );      

    } catch (error) { 
      
      dispatch({
        type: GS_SALES_GROUPS_CLASSIFY_FAILURE,
        payload: null
      });

      dispatch(appendStatus('An error occurred while trying to re-regenerate sales groups.', 'error'));      
    }
  }
}
